import React, { PureComponent } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';

import BankAccountForm from '../../global/forms/bankAccountForm';
import CreditCardForm from '../../global/forms/creditCardForm';

import ShowSuccessToasts from '../../global/successToast';
import ShowErrorToasts from '../../global/errorToast';

import { createAccount, createCustomer, updateFormData, updateBankDetails, updateBillingAddress, updateCreditCardDetails } from '../actions';
import { checkAuthorization } from '../../global/actions';
import { getUserProfileInfo } from '../../user/actions';
import { onLoginExpired } from './ownerForm3';


const mapStateToProps = state => ({
  global: state.Global,
  dashboard: state.Dashboard,
  registration: state.Registration,
  user: state.User
});

class OwnerForm2 extends PureComponent {
  constructor(props) {
    super(props);

    this.onSubmit = this.onSubmit.bind(this);
  }

  componentWillMount() {
    const { global, dispatch } = this.props;

    if (!global.userId) {
      onLoginExpired(dispatch);
      return;
    }

    dispatch(checkAuthorization());
    dispatch(getUserProfileInfo(global.userId));
  }

  componentDidUpdate(prevProps, prevState) {
    const { dispatch, userType } = this.props;
    const { formData } = this.props.registration;
    const { token } = this.props.global;

    const olderFormData = prevProps.registration.formData;

    if (userType === 'owner') {
      if (!!formData.accountNumber && formData.accountNumber !== olderFormData.accountNumber) {
        dispatch(updateBankDetails(token, userType, formData.brand, formData.accountNumber, formData.bnk_accountNumber, formData.routingNumber, formData.sourceId));
      }
    }
    else {
      if (!!formData.sourceId && formData.sourceId !== olderFormData.sourceId && !!formData.card_number) {
        dispatch(updateCreditCardDetails(token, formData.brand, formData.lastFour, formData.month, formData.year, formData.sourceId));
      }
    }
  }

  onSubmit = async (values, { setSubmitting }) => {
    const { dispatch, userType } = this.props;
    const { token, userId } = this.props.global;

    const { user } = this.props.user;

    if (!userId || !user) {
      onLoginExpired(dispatch);
      return;
    }

    values.bill_email = user.email;
    values.bill_phoneNumber = user.phoneNumber;

    const accFn = userType === 'owner' ? createAccount : createCustomer;
    const accnType = userType === 'owner' ? 'account' : 'customer';

    await dispatch(updateFormData(values));
    await dispatch(accFn(values))
      .then(resp => {
        dispatch(updateBillingAddress(token, userType, values, accnType))
      }).catch(error => {
        console.error(error);
      })

    setSubmitting(false);
  }

  onBack = () => {
    let { history } = this.props;
    history.goBack();
  }

  render() {
    const { userType } = this.props;
    let errors = this.props.global.errors
      ? this.props.global.errors.filter((e) => e.errType === "paymentmethod")
      : [];
    return (
      <div className="container">
        <ShowSuccessToasts />
        <ShowErrorToasts />
        <h1>Create Billing Account</h1>
        {
          userType === 'owner' ?
            <BankAccountForm onSubmit={this.onSubmit} onBack={this.onBack} errorMessage={errors[0]} /> :
            <CreditCardForm onSubmit={this.onSubmit} onBack={this.onBack} errorMessage={errors[0]} />
        }
      </div>
    )
  }
}

export default withRouter(connect(mapStateToProps)(OwnerForm2));
